import { useState } from "react";
import { ArrowRight, Mail } from "lucide-react";
import { motion } from "framer-motion";
import { toast } from "sonner";

const CapturaLeads = () => {
  const [form, setForm] = useState({ nome: "", email: "", etapa: "", cidade: "", aceite: false });

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.aceite) {
      toast.error("Por favor, aceite a política de privacidade para continuar.");
      return;
    }
    toast.success("Tudo certo! Em breve você receberá seu checklist.", {
      description: "Materiais selecionados para a sua etapa estão a caminho.",
    });
    setForm({ nome: "", email: "", etapa: "", cidade: "", aceite: false });
  };

  const inputClass =
    "w-full bg-white border border-maternnia-nevoa rounded-xl px-4 py-3 text-sm text-maternnia-charcoal placeholder:text-maternnia-taupe/70 focus:outline-none focus:ring-2 focus:ring-maternnia-pink/30 focus:border-maternnia-pink transition";

  return (
    <section id="cadastro" data-testid="captura-leads-section" className="bg-maternnia-porcelana py-24 md:py-32">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <motion.div
          className="bg-white rounded-[2rem] p-8 md:p-14 shadow-[0_24px_64px_rgba(43,37,38,0.10)] grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div>
            <span className="inline-flex items-center gap-2 bg-maternnia-pink/10 text-maternnia-pink text-xs font-medium px-4 py-2 rounded-full mb-6">
              <Mail size={14} /> Gratuito
            </span>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-maternnia-charcoal font-medium leading-[1.1]">
              Receba um checklist para a sua etapa.
            </h2>
            <p className="mt-5 text-base text-maternnia-taupe leading-relaxed font-light">
              Conte em que momento você está e receba conteúdos e materiais mais relevantes para a sua jornada.
            </p>
          </div>

          <form onSubmit={handleSubmit} data-testid="leads-form" className="space-y-4">
            <input
              data-testid="lead-nome"
              type="text" required placeholder="Seu nome"
              value={form.nome} onChange={(e) => update("nome", e.target.value)}
              className={inputClass}
            />
            <input
              data-testid="lead-email"
              type="email" required placeholder="Seu melhor e-mail"
              value={form.email} onChange={(e) => update("email", e.target.value)}
              className={inputClass}
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <select
                data-testid="lead-etapa" required
                value={form.etapa} onChange={(e) => update("etapa", e.target.value)}
                className={`${inputClass} ${form.etapa === "" ? "text-maternnia-taupe/70" : ""}`}
              >
                <option value="" disabled>Etapa atual</option>
                <option>Planejamento</option>
                <option>Gestação</option>
                <option>Parto</option>
                <option>Pós-parto</option>
              </select>
              <input
                data-testid="lead-cidade"
                type="text" placeholder="Cidade"
                value={form.cidade} onChange={(e) => update("cidade", e.target.value)}
                className={inputClass}
              />
            </div>
            <label className="flex items-start gap-3 cursor-pointer pt-1">
              <input
                data-testid="lead-aceite"
                type="checkbox"
                checked={form.aceite} onChange={(e) => update("aceite", e.target.checked)}
                className="mt-0.5 h-4 w-4 rounded border-maternnia-nevoa text-maternnia-pink focus:ring-maternnia-pink/30 accent-maternnia-pink"
              />
              <span className="text-xs text-maternnia-taupe leading-relaxed font-light">
                Concordo em receber conteúdos da Maternnia e li a política de privacidade.
              </span>
            </label>
            <button
              type="submit"
              data-testid="lead-submit"
              className="group w-full inline-flex items-center justify-center gap-2 bg-maternnia-pink text-white hover:bg-maternnia-pinkHover rounded-full px-8 py-4 text-base font-medium transition-all duration-300 hover:shadow-lg hover:scale-[1.01] active:scale-[0.99]"
            >
              Quero receber gratuitamente
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default CapturaLeads;
